import { useFormik } from 'formik'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CRow,
  CTableHeaderCell,
  CLoadingButton,
  CTableRow,
  CFormSelect,
  CFormLabel,
  CMultiSelect,
  CFormTextarea,
  CButton,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CInputGroup,
  CInputGroupText,
  CHeaderNav,
  CButtonGroup,
  CTooltip,
  CLink,
} from '@coreui/react-pro'

import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import ToastComponent from 'src/components/common/TaostComponent'
import ScorecardService from 'src/service/ScorecardService'
import CompleteMarkModal from './CompleteMarkModal'
import ClubService from 'src/service/ClubService'
import moment from 'moment'
import Loader from 'src/components/Loader'
import CIcon from '@coreui/icons-react'
import { cilInfo } from '@coreui/icons'
import MarkAsCompleteModal from './MarkAsCompleteModal'

const FullScoreCard = () => {
  const navigate = useNavigate()
  const [visible, setVisible] = useState(false)
  const [completMarkModalVisible, setCompletMarkModalVisible] = useState(false)
  const [finalScorecardModalVisible, setFinalScorecardModalVisible] = useState(false)
  const [defaultInning, setDefaultInning] = useState(1)
  const [scorecardDetails, setScorecardDetails] = useState([])
  const [playerList, setPlayerList] = useState([])
  const [fixtureDetails, setFixtureDetails] = useState({})
  const [loader, setLoader] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [statusValue, setStatusValue] = useState()
  const param = useParams()
  const [gameDetails, setGameDetails] = useState({})

  const fetchData = async (defaultInning = 1) => {
    setScorecardDetails([])
    try {
      const scorecardResponse = await ScorecardService.fullScorecardDetail(
        param.fixtureId,
        defaultInning,
      )
      if (scorecardResponse.status === 200) {
        setScorecardDetails(scorecardResponse.data)

        if (scorecardResponse.player_list.length < 5) {
          ToastComponent(
            'Please add a minimum of 5 players to the squad list of this fixture!',
            'error',
          )
          navigate(`/manage-scores/team-players/${param.fixtureId}`)
          return // Exit early if player list is insufficient
        }
        setPlayerList(scorecardResponse.player_list)
        setFixtureDetails(scorecardResponse.fixtureDetails)
        setStatusValue(scorecardResponse.fixtureDetails.status)
      }

      const clubResponse = await ClubService.getClubDetails()
      if (clubResponse.status === 200) {
        setLoader(false)
        setIsLoading(false)
        setGameDetails(clubResponse.game_details)
        console.log('gameDetails?.game_type', clubResponse?.game_details)
        if (clubResponse?.game_details?.game_type == 3) {
          navigate(`/indoor-full-scorecard/${param.fixtureId}`)
        } else {
          navigate(`/common-full-scorecard/${param.fixtureId}`)
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      // Handle error here, e.g., show an error toast
    }
  }

  useEffect(() => {
    fetchData()
    // Cleanup (if necessary)
    return () => {
      // Cleanup code here (if any)
    }
  }, [])
  const formik = useFormik({
    initialValues: {
      data: scorecardDetails,
      scorcard_link_name: fixtureDetails?.scorcard_link_name,
      scorcard_link_url: fixtureDetails?.scorcard_link_url,
      fall_of_wickets: fixtureDetails?.fall_of_wickets,
      match_report: fixtureDetails?.match_report,
      potm_match_status: fixtureDetails?.potm_match_status,
      match_status: '',
    },
    enableReinitialize: true,
    onSubmit: (data, actions) => {
      data.fixtureId = param.fixtureId
      data.potm = selectedValue
      data.status = statusValue
      data.inning = defaultInning
      setLoader(true)
      if (gameDetails?.game_type === 3) {
        ScorecardService.saveIndoorScorecard(data).then((res) => {
          if (res.status === 200) {
            fetchData()
            setLoader(false)
            ToastComponent(res.message, 'success')
          }
        })
      } else {
        ScorecardService.saveScorecard(data).then((res) => {
          if (res.status === 200) {
            fetchData()
            setLoader(false)
            ToastComponent(res.message, 'success')
          }
        })
      }
    },
  })
  const [selectedValue, setSelectedValue] = useState([])
  const handleChange = (e) => {
    setSelectedValue(Array.isArray(e) ? e.map((x) => x.value) : [])
  }
  const [completeMarkModalData, setCompleteMarkModalData] = useState([])
  const handleMatchStatus = (e) => {
    setStatusValue(e.target.value)
    const data = {}
    data.fixtureId = param.fixtureId
    data.status = e.target.value
    if (e.target.value === '2') {
      ScorecardService.getSavedScorecardData(data).then((res) => {
        if (res.status === 200) {
          setCompleteMarkModalData(res.data)
          setCompletMarkModalVisible(true)
        }
      })
    } else {
      formikRef.current.handleSubmit()
      ScorecardService.changFixtureStatus(param.fixtureId, e.target.value)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            navigate(`/full-scorecard/${param.fixtureId}`)
          } else {
            ToastComponent(res.message, 'error')
          }
        })
        .catch((e) => {
          console.log('e', e)
          ToastComponent('Something went wrong.', 'error')
        })
    }
  }

  const formikRef = React.useRef()
  useEffect(() => {
    formikRef.current = formik
  }, [formik])

  const changeInning = (e) => {
    setDefaultInning(e.target.value)
    fetchData(e.target.value)
  }

  const [isMobile, setIsMobile] = useState(false)
  // Function to update the isMobile state based on the screen width
  const updateScreenSize = () => {
    setIsMobile(window.innerWidth <= 768) // Adjust the breakpoint as needed
  }
  // Use useEffect to update the screen size state on component mount and window resize
  useEffect(() => {
    updateScreenSize() // Initial check
    window.addEventListener('resize', updateScreenSize)

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', updateScreenSize)
    }
  }, [])
  function formatFantasyPoints(fantasyPoints) {
    // Check if there are decimal digits
    if (fantasyPoints % 1 !== 0) {
      return fantasyPoints.toFixed(2).replace(/0+$/, '') // Remove trailing zeros
    } else {
      return fantasyPoints.toString() // Convert to a string without decimal places
    }
  }
  const [infoPageModal, setInfoPageModal] = useState(false)
  const handleInfoClick = () => {
    setInfoPageModal(true)
  }

  const handleInputChange = (event, type) => {
    formik.handleChange(event) // Update formik state
    const data = {}
    data.fixtureId = param.fixtureId
    data.type = type
    data.value = event.target.value
    ScorecardService.updateCustomScorecardField(data).then((res) => {
      if (res.status === 200) {
        setLoader(false)
        ToastComponent(res.message, 'success')
      }
    })
  }
  return (
    <>
      <>
        <CForm className="row g-3" onSubmit={formik.handleSubmit}>
          <CRow>
            <CCol xs={12} md={3} className="pt-3 pb-2">
              <span>
                <b> Round</b>: {fixtureDetails.round}
              </span>
            </CCol>
            <CCol xs={12} md={3} className="pt-3 pb-2">
              <span>
                <b> Team</b>: {fixtureDetails.team_name}
              </span>
            </CCol>
            <CCol xs={12} md={3} className="pt-3 pb-2">
              <span>
                <b> Start Date/Time</b>: {moment(fixtureDetails.start_date).format('D.MM.YYYY')}
                {', '}
                {moment(fixtureDetails.start_time, ['HH:mm']).format('h:mma')}
              </span>
            </CCol>
            <CCol xs={12} md={3} className="pt-3 pb-2">
              <span>
                <b> End Date/Time</b>: {moment(fixtureDetails.end_date).format('D.MM.YYYY')}
                {', '}
                {moment(fixtureDetails.end_time, ['HH:mm']).format('h:mma')}
              </span>
            </CCol>

            {fixtureDetails?.match_type === '2-Day' && (
              <CCol xs={12} md={3} className="pt-3 pb-2">
                <CFormLabel className="fw-bold" htmlFor="Country">
                  Inning
                </CFormLabel>
                <CFormSelect
                  aria-label="select inning"
                  name="inning"
                  onChange={changeInning}
                  className={
                    'form-control' +
                    (formik.errors.inning && formik.touched.inning ? ' is-invalid' : '')
                  }
                  id="inning"
                >
                  <option value={1}>1st Innings</option>
                  <option value={2}>2nd Innings</option>
                </CFormSelect>
              </CCol>
            )}

            {isMobile ? (
              <CCol xs={12}>
                <CCard className="mb-4">
                  <CCardHeader>
                    <strong>
                      <strong>
                        {fixtureDetails.scorcard_link_url ? (
                          <Link to={fixtureDetails.scorcard_link_url} target="_blank">
                            Scorecard
                          </Link>
                        ) : (
                          'Scorecard'
                        )}
                      </strong>
                    </strong>
                  </CCardHeader>
                  <CCardBody>
                    {loader ? (
                      <Loader />
                    ) : (
                      <CAccordion alwaysOpen>
                        {scorecardDetails &&
                          scorecardDetails.map((item, key) => (
                            <CAccordionItem itemKey={key} key={key}>
                              <CAccordionHeader>{item.player_name}</CAccordionHeader>
                              <CAccordionBody>
                                <CRow className="mb-2">
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Runs
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]rs`}
                                        type={'number'}
                                        defaultValue={item.rs}
                                        onChange={formik.handleChange}
                                        className="col-sm-10"
                                        id="rs"
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Ball Faced
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]bf`}
                                        type={'number'}
                                        defaultValue={item.bf}
                                        onChange={formik.handleChange}
                                        className="col-sm-10"
                                        id="bf"
                                      />
                                    </CInputGroup>
                                  </div>

                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                        type={'number'}
                                      >
                                        Fours
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]fours`}
                                        defaultValue={item.fours}
                                        onChange={formik.handleChange}
                                        id="fours"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Sixes
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]sixes`}
                                        defaultValue={item.sixes}
                                        onChange={formik.handleChange}
                                        id="sixes"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Overs
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]overs`}
                                        defaultValue={item.overs}
                                        onChange={formik.handleChange}
                                        id="OVRS"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Maidens
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]mdns`}
                                        defaultValue={item.mdns}
                                        onChange={formik.handleChange}
                                        id="mdns"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Runs Given
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]run`}
                                        defaultValue={item.run}
                                        onChange={formik.handleChange}
                                        id="run"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Wickets
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]wks`}
                                        defaultValue={item.wks}
                                        onChange={formik.handleChange}
                                        id="wks"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Catches
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]cs`}
                                        defaultValue={item.cs}
                                        onChange={formik.handleChange}
                                        id="cs"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Catches-WK
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]cwks`}
                                        defaultValue={item.cwks}
                                        onChange={formik.handleChange}
                                        id="cwks"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Stumpings
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]sts`}
                                        defaultValue={item.sts}
                                        onChange={formik.handleChange}
                                        id="sts"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>

                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Run-Out Direct
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]rods`}
                                        defaultValue={item.rods}
                                        onChange={formik.handleChange}
                                        id="rods"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Run-Out Assist
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]roas`}
                                        defaultValue={item.roas}
                                        onChange={formik.handleChange}
                                        id="roas"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Duck
                                      </CInputGroupText>
                                      <CFormSelect
                                        id="dks"
                                        values={item.dks}
                                        name={`data[${key}]dks`}
                                        defaultValue={item.dks}
                                        onChange={formik.handleChange}
                                        disabled={true}
                                      >
                                        <option value={0}>No</option>
                                        <option value={1}>Yes</option>
                                      </CFormSelect>
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                        disabled={true}
                                      >
                                        Hat-Trick
                                      </CInputGroupText>
                                      <CFormSelect
                                        id="hattrick"
                                        values={item.hattrick}
                                        name={`data[${key}]hattrick`}
                                        defaultValue={item.hattrick}
                                        onChange={formik.handleChange}
                                        disabled={true}
                                      >
                                        <option value={0}>No</option>
                                        <option value={1}>Yes</option>
                                      </CFormSelect>
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                        disabled={true}
                                      >
                                        Not Out
                                      </CInputGroupText>
                                      <CFormSelect
                                        id="no"
                                        values={item.no}
                                        name={`data[${key}]no`}
                                        defaultValue={item.no}
                                        onChange={formik.handleChange}
                                        disabled={true}
                                      >
                                        <option value={0}>No</option>
                                        <option value={1}>Yes</option>
                                      </CFormSelect>
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        How Out
                                      </CInputGroupText>
                                      <CFormSelect
                                        id="hwot"
                                        values={item.hwot}
                                        name={`data[${key}]hwot`}
                                        defaultValue={item.hwot}
                                        onChange={formik.handleChange}
                                        disabled={true}
                                      >
                                        <option value={''}>Select Dismissal</option>
                                        <option value={'hobwl'}>Bowled</option>
                                        <option value={'hoct'}>Catch</option>
                                        <option value={'hocwk'}>Catch WK</option>
                                        <option value={'holbw'}>LBW</option>
                                        <option value={'host'}>Stump</option>
                                        <option value={'horod'}>RO-Direct</option>
                                        <option value={'horoa'}>RO-Assist</option>
                                        <option value={'hohw'}>Hit Wicket</option>
                                        <option value={'hohb'}>Handled-Ball</option>
                                        <option value={'hoobs'}>Obstruct</option>
                                        <option value={'hotmd'}>Timed</option>
                                      </CFormSelect>
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        WKT Bowled
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]wb`}
                                        defaultValue={item.wb}
                                        onChange={formik.handleChange}
                                        id="wb"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        WKT Catch
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]wct`}
                                        defaultValue={item.wct}
                                        onChange={formik.handleChange}
                                        id="wct"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        WKT Catch WK
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]wcwk`}
                                        defaultValue={item.wcwk}
                                        onChange={formik.handleChange}
                                        id="wcwk"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        WKT LBW
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]wlbw`}
                                        defaultValue={item.wlbw}
                                        onChange={formik.handleChange}
                                        id="wlbw"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        WKT Stump
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]wst`}
                                        defaultValue={item.wst}
                                        onChange={formik.handleChange}
                                        id="wst"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        WKT Hit Wicket
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]whw`}
                                        defaultValue={item.whw}
                                        onChange={formik.handleChange}
                                        id="whw"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Dots Played
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]dotp`}
                                        defaultValue={item.dotp}
                                        onChange={formik.handleChange}
                                        id="dotp"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Dots Bowled
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        name={`data[${key}]dotb`}
                                        defaultValue={item.dotb}
                                        onChange={formik.handleChange}
                                        id="dotb"
                                        type={'number'}
                                      />
                                    </CInputGroup>
                                  </div>

                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText
                                        id="inputGroup-sizing-default"
                                        style={{ width: '135px' }}
                                      >
                                        Fantasy Points
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled={true}
                                        defaultValue={formatFantasyPoints(item.fantasy_points)}
                                        id="fantasy_points"
                                      />
                                    </CInputGroup>
                                  </div>
                                </CRow>
                              </CAccordionBody>
                            </CAccordionItem>
                          ))}
                      </CAccordion>
                    )}
                  </CCardBody>
                </CCard>
              </CCol>
            ) : (
              <CCol xs={12}>
                <CCard className="mb-4">
                  <CCardHeader>
                    <strong>
                      {fixtureDetails.scorcard_link_url ? (
                        <Link to={fixtureDetails.scorcard_link_url} target="_blank">
                          Scorecard
                        </Link>
                      ) : (
                        'Scorecard'
                      )}
                    </strong>
                  </CCardHeader>
                  <CCardBody>
                    {loader ? (
                      <Loader />
                    ) : (
                      <div className="table-responsive" style={{ overflowX: 'auto' }}>
                        <table
                          className="main-table table innertable"
                          style={{ borderCollapse: 'collapse', width: '100%' }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  position: 'sticky',
                                  left: 0,
                                  zIndex: 2,
                                  backgroundColor: '#fff',
                                  width: '150px', // Adjust width as needed
                                }}
                              >
                                PLAYER
                              </th>
                              <th>
                                <CTooltip content="Position">
                                  <CLink> POS </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Fantasy Points">
                                  <CLink> FP </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Runs">
                                  <CLink> RS </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Balls Faced">
                                  <CLink> BF </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Fours">
                                  <CLink> 4S </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Sixes">
                                  <CLink> 6S </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Overs">
                                  <CLink> OVRS </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Maidens">
                                  <CLink> MDNS </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Runs Given">
                                  <CLink> RG </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Wickets">
                                  <CLink> WKTS </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Catches">
                                  <CLink> CS </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Catches (Wicket-Keeper)">
                                  <CLink> CWK </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Stumpings">
                                  <CLink> ST </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Run-Out Direct">
                                  <CLink> ROD </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Run-Out Assist">
                                  <CLink> ROA </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Duck">
                                  <CLink> DK </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Hat-Trick">
                                  <CLink> HT </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Not Out">
                                  <CLink> NO </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="How Out (Batting)">
                                  <CLink> HWOT </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Wicket Dismissal (Bowled)">
                                  <CLink> WB </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Wicket Dismissal (Caught)">
                                  <CLink> WCT </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Wicket Dismissal (Caught WK)">
                                  <CLink> WCWK </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Wicket Dismissal (LBW)">
                                  <CLink> WLBW </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Wicket Dismissal (Stump)">
                                  <CLink> WST </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Wicket Dismissal (Hit Wicket)">
                                  <CLink> WHW </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Dots Played">
                                  <CLink> DOTP </CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Dots Bowled">
                                  <CLink> DOTB </CLink>
                                </CTooltip>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {scorecardDetails &&
                              scorecardDetails.map((item, key) => (
                                <tr key={key}>
                                  <td
                                    style={{
                                      position: 'sticky',
                                      left: 0,
                                      zIndex: 1,
                                      backgroundColor: '#f9f9f9',
                                      width: '35px',
                                    }}
                                  >
                                    {item.player_name}
                                  </td>
                                  <td>
                                    {item?.player_position == 1 ? 'BAT' : ''}
                                    {item?.player_position == 2 ? 'BOWL' : ''}
                                    {item?.player_position == 3 ? 'AR' : ' '}
                                    {item?.player_position == 4 ? 'WK' : ''}
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      defaultValue={formatFantasyPoints(item.fantasy_points)}
                                      id="fantasy_points"
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]rs`}
                                      type={'number'}
                                      defaultValue={item.rs}
                                      onChange={formik.handleChange}
                                      id="rs"
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]bf`}
                                      type={'number'}
                                      defaultValue={item.bf}
                                      onChange={formik.handleChange}
                                      id="bf"
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]fours`}
                                      defaultValue={item.fours}
                                      onChange={formik.handleChange}
                                      type={'number'}
                                      id="fours"
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]sixes`}
                                      defaultValue={item.sixes}
                                      onChange={formik.handleChange}
                                      id="sixes"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]overs`}
                                      defaultValue={item.overs}
                                      onChange={formik.handleChange}
                                      id="OVRS"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]mdns`}
                                      defaultValue={item.mdns}
                                      onChange={formik.handleChange}
                                      id="mdns"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]run`}
                                      defaultValue={item.run}
                                      onChange={formik.handleChange}
                                      id="run"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]wks`}
                                      defaultValue={item.wks}
                                      onChange={formik.handleChange}
                                      id="wks"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]cs`}
                                      defaultValue={item.cs}
                                      onChange={formik.handleChange}
                                      id="cs"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]cwks`}
                                      defaultValue={item.cwks}
                                      onChange={formik.handleChange}
                                      id="cwks"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]sts`}
                                      defaultValue={item.sts}
                                      onChange={formik.handleChange}
                                      id="sts"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]rods`}
                                      defaultValue={item.rods}
                                      onChange={formik.handleChange}
                                      id="rods"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]roas`}
                                      defaultValue={item.roas}
                                      onChange={formik.handleChange}
                                      id="roas"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormSelect
                                      id="dks"
                                      values={item.dks}
                                      name={`data[${key}]dks`}
                                      defaultValue={item.dks}
                                      onChange={formik.handleChange}
                                      style={{ minWidth: '70px' }}
                                      disabled={true}
                                    >
                                      <option value={0}>No</option>
                                      <option value={1}>Yes</option>
                                    </CFormSelect>
                                  </td>
                                  <td>
                                    <CFormSelect
                                      id="hattrick"
                                      values={item.hattrick}
                                      name={`data[${key}]hattrick`}
                                      defaultValue={item.hattrick}
                                      onChange={formik.handleChange}
                                      style={{ minWidth: '70px' }}
                                      disabled={true}
                                    >
                                      <option value={0}>No</option>
                                      <option value={1}>Yes</option>
                                    </CFormSelect>
                                  </td>
                                  <td>
                                    <CFormSelect
                                      id="no"
                                      values={item.no}
                                      name={`data[${key}]no`}
                                      defaultValue={item.no}
                                      onChange={formik.handleChange}
                                      style={{ minWidth: '70px' }}
                                      disabled={true}
                                    >
                                      <option value={0}>No</option>
                                      <option value={1}>Yes</option>
                                    </CFormSelect>
                                  </td>

                                  <td>
                                    <CFormSelect
                                      id="hwot"
                                      values={item.hwot}
                                      name={`data[${key}]hwot`}
                                      defaultValue={item.hwot}
                                      onChange={formik.handleChange}
                                      style={{ minWidth: '70px' }}
                                      disabled={true}
                                    >
                                      <option value={''}>Select Dismissal</option>
                                      <option value={'hobwl'}>Bowled</option>
                                      <option value={'hoct'}>Catch</option>
                                      <option value={'hocwk'}>Catch WK</option>
                                      <option value={'holbw'}>LBW</option>
                                      <option value={'host'}>Stump</option>
                                      <option value={'horod'}>RO-Direct</option>
                                      <option value={'horoa'}>RO-Assist</option>
                                      <option value={'hohw'}>Hit Wicket</option>
                                      <option value={'hohb'}>Handled-Ball</option>
                                      <option value={'hohb'}>Handled-Ball</option>
                                      <option value={'hoobs'}>Obstruct</option>
                                      <option value={'hotmd'}>Timed</option>
                                    </CFormSelect>
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]wb`}
                                      defaultValue={item.wb}
                                      onChange={formik.handleChange}
                                      id="wb"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]wct`}
                                      defaultValue={item.wct}
                                      onChange={formik.handleChange}
                                      id="wct"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]wcwk`}
                                      defaultValue={item.wcwk}
                                      onChange={formik.handleChange}
                                      id="wcwk"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]wlbw`}
                                      defaultValue={item.wlbw}
                                      onChange={formik.handleChange}
                                      id="wlbw"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]wst`}
                                      defaultValue={item.wst}
                                      onChange={formik.handleChange}
                                      id="wst"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]whw`}
                                      defaultValue={item.whw}
                                      onChange={formik.handleChange}
                                      id="whw"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]dotp`}
                                      defaultValue={item.dotp}
                                      onChange={formik.handleChange}
                                      id="dotp"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                  <td>
                                    <CFormInput
                                      disabled={true}
                                      name={`data[${key}]dotb`}
                                      defaultValue={item.dotb}
                                      onChange={formik.handleChange}
                                      id="dotb"
                                      type={'number'}
                                      style={{ minWidth: '70px' }}
                                    />
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </CCardBody>
                </CCard>
              </CCol>
            )}
            <CCol xs={12}>
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>Scorecard Details</strong>
                </CCardHeader>
                <CCardBody>
                  <CRow>
                    <CCol md={6}>
                      <CFormLabel htmlFor="phone">Scorecard Source</CFormLabel>
                      <input
                        type="text"
                        name="scorcard_link_name"
                        className={'form-control'}
                        id="scorcard_link_name"
                        placeholder="Scorecard Source"
                        defaultValue={formik.values.scorcard_link_name}
                        onChange={(e) => handleInputChange(e, 'scorcard_link_name')}
                      />
                    </CCol>
                    <CCol md={6}>
                      <CFormLabel htmlFor="phone">Scorecard Link</CFormLabel>
                      <input
                        type="text"
                        name="scorcard_link_url"
                        className={'form-control'}
                        id="scorcard_link_url"
                        placeholder="Scorecard Link"
                        defaultValue={formik.values.scorcard_link_url}
                        onChange={(e) => handleInputChange(e, 'scorcard_link_url')}
                      />
                    </CCol>

                    <CCol md={6}>
                      <CFormLabel htmlFor="fall_of_wickets" className="mt-3">
                        Fall of Wickets
                      </CFormLabel>
                      <CFormTextarea
                        aria-label="With textarea"
                        defaultValue={formik.values.fall_of_wickets}
                        name={'fall_of_wickets'}
                        onChange={(e) => handleInputChange(e, 'fall_of_wickets')}
                      ></CFormTextarea>
                    </CCol>
                    {/* <CCol md={6}>
              <CFormLabel htmlFor="Add Match Report" className="mt-3">
                Add Match Report
              </CFormLabel>
              <CFormTextarea
                aria-label="With textarea"
                defaultValue={formik.values.match_report}
                name={'match_report'}
                onChange={formik.handleChange}
              ></CFormTextarea>
            </CCol> */}
                    {/* <CCol md={6} className="mb-4">
              <CFormLabel htmlFor="formFile" className="mt-3">
                Upload Match Scorecard
              </CFormLabel>
              <CFormInput
                disabled={true}
               type="file" id="upload_video" />
            </CCol> */}
                  </CRow>
                </CCardBody>
              </CCard>
              <CompleteMarkModal visible={visible} setVisible={setVisible} />

              {/* <MarkAsCompleteModal
        completMarkModalVisible={completMarkModalVisible}
        setCompletMarkModalVisible={setCompletMarkModalVisible}
        data={completeMarkModalData}
      /> */}
            </CCol>
            <CCol xs={12}>
              <CCard className="mb-4 mt-3">
                <CCardHeader>
                  <strong>Match Status</strong>
                </CCardHeader>
                <CCardBody>
                  <CRow>
                    <CCol md={6}>
                      <CFormLabel htmlFor="Add Match Report" className="mr-1 mt-3">
                        Match Status
                      </CFormLabel>
                      <CButton color="danger" size="sm" onClick={() => setVisible(!visible)}>
                        <CIcon icon={cilInfo} className="" fontSize={12} />
                      </CButton>
                      <CFormSelect
                        aria-label="Select Structure"
                        name="match_status"
                        className={
                          'mt-3 form-control' +
                          (formik.errors.match_status && formik.touched.match_status
                            ? ' is-invalid'
                            : '')
                        }
                        value={statusValue}
                        id="match_status"
                        onChange={handleMatchStatus}
                      >
                        <option value={0}>Select Match Status </option>
                        <option value={1}>In-Progress</option>
                        <option value={2}>Completed</option>
                      </CFormSelect>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CForm>
        <CompleteMarkModal visible={visible} setVisible={setVisible} />
        <MarkAsCompleteModal
          completMarkModalVisible={completMarkModalVisible}
          setCompletMarkModalVisible={setCompletMarkModalVisible}
          data={completeMarkModalData}
          fixtureId={param.fixtureId}
          finalScorecardModalVisible={finalScorecardModalVisible}
          setFinalScorecardModalVisible={setFinalScorecardModalVisible}
        />
      </>
    </>
  )
}

export default FullScoreCard
